import { FC, useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { Modal, TextAreaField, SelectField, Button, ButtonSubmit } from 'components';

import SectionStyled from './styles';

interface Props {}

const ContactWorker: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      console.log(values);
      setVisible(false);
    },
  });

  return (
    <>
      <button onClick={() => setVisible(true)}>Open modal ContactWorker</button>
      <Modal title="工事担当者へ連絡" visible={visible} footer={false} width={640}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select">
                  <Form.Item className="input-onsite" label="監督名" colon={false} name="onsite">
                    <SelectField
                      data={onsites}
                      name="onsite"
                      className="select-field"
                      placeholder="監督-現場を選択してください"
                    />
                  </Form.Item>
                </div>
                <Form.Item className="note-field" label="内容" name="content" colon={false}>
                  <TextAreaField
                    name="content"
                    className="text-area"
                    placeholder="連絡事項を入力してください"
                    autoSize={{ maxRows: 5 }}
                  />
                </Form.Item>
              </div>
              <div className="ant-modal-footer">
                <Button className="button-secondary" onClick={() => setVisible(false)}>
                  キャンセル
                </Button>
                <ButtonSubmit>送信</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

const onsites = [
  { label: 'name 1', value: 1 },
  { label: 'name 2', value: 2 },
  { label: 'name 3', value: 3 },
  { label: 'name 4', value: 4 },
  { label: 'name 5', value: 5 },
  { label: 'name 6', value: 6 },
];

const initialValues = {
  onsite: '',
  content: '',
};

const validationSchema = yup.object().shape({
  onsite: yup.number().required().label('現場'),
  content: yup.string().required().label('内容'),
});

export default ContactWorker;
